// CSS Modules - component class name prefix: GoogleMaps__

<template>
  <div :class="$style.container">
    <div ref="map" :class="$style.map"></div>
  </div>
</template>

<script>
export default {
  name: "GoogleMaps",
  props: {
    config: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      apiKey: "AIzaSyCqP9WhqxjG_YMk3XSFjiG3zOKRD9wGKAs",
      address: `${this.config.street},${this.config.zip} ${this.config.city},${this.config.country}`,
      infoWindow: null,
      map: null,
      mapOptions: {
        zoom: 15,
        disableDefaultUI: false,
        scaleControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        mapTypeControl: false,
        mapTypeId: null
      }
    };
  },
  methods: {
    callInit: function() {
      setTimeout(() => {
        if (typeof google === "object" && typeof google.maps === "object") {
          this.initGMaps();
        } else {
          this.callInit();
        }
      }, 200);
    },
    initGMaps() {
      this.mapOptions.mapTypeId = google.maps.MapTypeId.HYBRID;
      const config = this.config;
      let directionsURL = "";
      let contentString =
        '<style type="text/css">img[src*="gstatic.com/"], img[src*="googleapis.com/"] { max-width: 99999px; };</style><div style="width:260px; height:100px;">';
      contentString +=
        '<table border="0" cellpadding="0" cellspacing="0" width="260" style="margin-top: 5px;><tr valign="top"><td width="50" style="padding: 0px; border: none;"><img src="' +
        config.logo +
        '" width="50" border="0"></td><td width="5" style="padding: 0px; border: none;"></td><td width="205" style="padding: 0px; border: none; font-family: Arial, Helvetica; font-size: 11px; font-weight: normal; line-height: 1.4;">';
      contentString += "<b>" + config.company + "</b><br/>";
      if (config.addInfo !== "") contentString += config.addInfo + "<br/>";
      contentString +=
        config.street + "<br />" + config.zip + " " + config.city + "<br /><br />";
      if (config.directionsText !== "") {
        if (
          typeof config.latitude !== "undefined" &&
          config.latitude !== "" &&
          typeof config.longitude !== "undefined" &&
          config.longitude !== ""
        ) {
          directionsURL =
            "http://maps.google.com/?q=" +
            escape(config.latitude + "," + config.longitude) +
            "&hl=" +
            config.language;
        } else {
          directionsURL =
            "http://maps.google.com/?daddr=" +
            escape(config.street + "," + config.zip + " " + config.city + "," + config.country) +
            "&hl=" +
            config.language;
        }

        contentString +=
          '<b><a href="' +
          directionsURL +
          '" target="_blank">' +
          config.directionsText +
          "</a></b>";
      }
      contentString += "</td></tr></table></div>";

      this.infoWindow = new google.maps.InfoWindow({
        content: contentString,
        maxWidth: 300
      });

      this.map = new google.maps.Map(this.$refs.map, this.mapOptions);

      if (
        typeof config.latitude !== "undefined" &&
        config.latitude !== "" &&
        typeof config.longitude !== "undefined" &&
        config.longitude !== ""
      ) {
        const newLatLng = new google.maps.LatLng(
          config.latitude,
          config.longitude
        );

        this.map.setCenter(newLatLng);

        const marker = new google.maps.Marker({
          position: newLatLng,
          map: this.map,
          icon: config.marker,
          title: config.company,
          flat: true
        });

        google.maps.event.addListener(marker, "click", () => {
          this.infoWindow.open(this.map, marker);
        });

        this.infoWindow.open(this.map, marker);
      } else {
        const geocoder = new google.maps.Geocoder();
        const geoReq = {
          address: this.address,
          language: config.language,
          country: config.ccTLD
        };

        geocoder.geocode(geoReq, (results, status) => {
          if (status === google.maps.GeocoderStatus.OK && results.length) {
            if (status !== google.maps.GeocoderStatus.ZERO_RESULTS) {
              this.map.setCenter(results[0].geometry.location);

              const marker = new google.maps.Marker({
                position: results[0].geometry.location,
                map: this.map,
                icon: config.marker,
                title: config.company,
                flat: true
              });

              google.maps.event.addListener(marker, "click", () => {
                this.infoWindow.open(this.map, marker);
              });

              this.infoWindow.open(this.map, marker);
            }
          }
        });
      }
    }
  },
  mounted() {
    if (typeof google === "undefined" && !window.googleApiInHead) {
      window.googleApiInHead = true;
      const script = document.createElement("script");
      if (this.config.language) {
        script.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&language=${this.config.language}`;
      } else {
        script.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}`;
      }
      script.setAttribute("async", "");
      script.setAttribute("defer", "");
      script.onload = this.callInit;
      document.head.appendChild(script);
    } else if (window.googleApiInHead) {
      this.callInit();
    }
  }
};
</script>

<style module lang="scss">
@import "./GoogleMaps.scss";
</style>
